"use strict";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger);

import SimpleBar from "simplebar";

/******************
 * 戻るボタン
 ******************/
ScrollTrigger.create({
  trigger: ".section__back",
  endTrigger: ".js-people-bottom",
  pin: true,
  // markers: true,
  start: "top 20%",
  end: "top 20%",
});

/******************
 * タイトルアニメ
 ******************/
const ttlAnime = document.querySelectorAll(".people-kv__ttl");
ttlAnime.forEach((item, index) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 75%",
    once: true,
    onEnter: () => {
      item.classList.add("is-active");
    },
  });
});

/******************
 * 3の質問
 ******************/
const peopleBottom = document.querySelectorAll(".js-people-bottom");
peopleBottom.forEach((item) => {
  const peopleBottomMask = document.getElementById("js-people-bottom-mask");
  const peopleBottomTtl = document.getElementById("js-people-bottom-ttl");
  ScrollTrigger.create({
    trigger: item,
    start: "top 35%",
    once: true,
    onEnter: () => {
      peopleBottomMask.classList.add("is-active");
      setTimeout(() => {
        peopleBottomTtl.classList.add("is-active");
      }, "500");
    },
    // markers: true,
  });
});
const peopleBottomCard = document.querySelectorAll(".js-people-bottom-card");
peopleBottomCard.forEach((item) => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 55%",
    once: true,
    onEnter: () => {
      item.classList.add("is-active");
    },
    // markers: true,
  });
});
